module.exports = __webpack_public_path__ + "img/8.558caf58.png";